import { render } from "./ImportantLinksServiceParameter.vue?vue&type=template&id=b4b8f4c6"
import script from "./ImportantLinksServiceParameter.vue?vue&type=script&lang=ts"
export * from "./ImportantLinksServiceParameter.vue?vue&type=script&lang=ts"
script.render = render

export default script